<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">
            <x-form-group
                label="Tanggal"
                :error="getError('date')"
                :is-required="true"
            >
                <input
                    type="date"
                    class="form-control"
                    v-model="fields.date"
                    required
                />
            </x-form-group>

            <x-form-group
                label="Deskripsi"
                :error="getError('description')"
                :is-required="false"
            >
                <textarea class="form-control" v-model="fields.description" />
            </x-form-group>

            <x-form-group
                label="Kehadiran"
                :error="getError('member_ids')"
                :is-required="false"
            >
                <a
                    href="javacript:;"
                    @click.prevent="toggleCheckAll"
                    v-if="!disabled"
                >
                    {{ allChecked ? "Hapus semua centang" : "Centang semua" }}
                </a>
                <x-table :headers="['Anggota']" :is-loading="isLoading">
                    <tr
                        v-for="(member, index) in availableMembers"
                        :key="index"
                        v-show="!isLoading"
                    >
                        <td>
                            <x-checkbox-wrapper :label="member.name">
                                <input
                                    type="checkbox"
                                    v-model="fields.member_ids"
                                    :value="member.id"
                                />
                            </x-checkbox-wrapper>
                        </td>
                    </tr>
                </x-table>
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XAddItemButton from "../../components/XAddItemButton.vue";
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XCheckboxWrapper from "../../components/XCheckboxWrapper.vue";
import XDeleteItemButton from "../../components/XDeleteItemButton.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XTable from "../../components/XTable.vue";
import { dateFormat } from "../../constants";
import { handleGeneralXhrError } from "../../helpers";
import FormErrorMixin from "../../mixins/FormErrorMixin";

export default {
    components: {
        XFormGroup,
        XFilterBox,
        XCheckboxWrapper,
        XTable,
        XAddItemButton,
        XAjaxDropdown,
        XDeleteItemButton,
    },
    computed: {
        allChecked() {
            return (
                this.fields.member_ids.length >= this.availableMembers.length
            );
        },
    },
    created() {
        this.fetchAvailableMembers();
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
    },
    data() {
        return {
            availableMembers: [],
            fields: {
                date: moment().format(dateFormat),
                description: null,
                group_id: this.$route.query.group_id,
                member_ids: [],
            },
            isLoading: false,
        };
    },
    methods: {
        checkAll() {
            this.fields.member_ids = this.availableMembers.map(
                (member) => member.id
            );
        },
        fetchAvailableMembers() {
            this.isLoading = true;
            const request = axios
                .get(`/api/groups/${this.$route.query.group_id}/members`)
                .then((response) => {
                    this.availableMembers = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleSubmit() {
            this.$emit("submit", { ...this.fields });
        },
        toggleCheckAll() {
            if (this.allChecked) {
                this.uncheckAll();
                return;
            }
            this.checkAll();
        },
        uncheckAll() {
            this.fields.member_ids = [];
        },
    },
    mixins: [FormErrorMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
};
</script>
